import booking from './md/booking.md?raw';
import bookingOnRequest from './md/booking--on-request.md?raw';
import bookingCC from './md/booking--bt.md?raw';
import bookingBT from './md/booking--cc.md?raw';

import bookingConfirmed from './md/booking-confirmed.md?raw';
import bookingConfirmedOnRequest from './md/booking-confirmed--on-request.md?raw';
import bookingConfirmedCC from './md/booking-confirmed--cc.md?raw';
import bookingConfirmedBT from './md/booking-confirmed--bt.md?raw';

import editGuard from './md/edit-guard.md?raw';
import amendBooking from './md/booking-amend.md?raw';
import cancelBooking from './md/booking-cancel.md?raw';
import requestBooking from './md/booking-request.md?raw';

import searchRequired from './md/search-required.md?raw';

import passwordResetDescription from './md/password-reset--description.md?raw';
import passwordResetComplete from './md/password-reset--complete.md?raw';
import passwordResetErrorUnknown from './md/password-reset--error--unknown.md?raw';

import setPasswordErrorUnknown from './md/set-password--error--unknown.md?raw';
import setPasswordErrorExpired from './md/set-password--error--expired.md?raw';
export default {
  setPassword: {
    error: {
      unknown: setPasswordErrorUnknown,
      expired: setPasswordErrorExpired,
    },
  },
  passwordReset: {
    description: passwordResetDescription,
    complete: passwordResetComplete,
    error: {
      unknown: passwordResetErrorUnknown,
    },
  },
  amendBooking,
  editGuard,
  searchRequired,
  booking: {
    cancel: cancelBooking,
    request: requestBooking,
    default: booking,
    onRequest: bookingOnRequest,
    cc: bookingCC,
    bt: bookingBT,
    confirmed: {
      default: bookingConfirmed,
      onRequest: bookingConfirmedOnRequest,
      cc: bookingConfirmedCC,
      bt: bookingConfirmedBT,
    },
  },
};
